module.exports = __webpack_public_path__ + "img/610a.e3c7cc2c.png";